import React from "react";

import NoteSummary from "../../consults/voice-notes/components/VoiceNoteCard/NoteSummary";
import type { VoiceNote } from "../../consults/voice-notes/types/VoiceNotes";

const EMPTY_TIPS_STATE = {
  viewTranscript: false,
  selectImageToSimulate: false,
};

const noopSaveSummary = (_note: VoiceNote) => {};
const noopCancelEdit = () => {};
const noopMarkStepComplete = (_step: unknown) => {};
const noopSetEditedSummary = (_value: string) => {};

type ConsultNoteSummaryProps = {
  note: VoiceNote;
  expandedSummaries: Record<string, boolean>;
  onToggleSummary: (noteId: string) => void;
};

const ConsultNoteSummary: React.FC<ConsultNoteSummaryProps> = ({
  note,
  expandedSummaries,
  onToggleSummary,
}) => {
  return (
    <NoteSummary
      note={note}
      editingNoteId={null}
      editingField={null}
      editedSummary=""
      expandedSummaries={expandedSummaries}
      saving={false}
      tipsEnabled={false}
      tipsState={EMPTY_TIPS_STATE}
      onSaveSummary={noopSaveSummary}
      onCancelEdit={noopCancelEdit}
      onToggleSummary={onToggleSummary}
      onMarkStepComplete={noopMarkStepComplete}
      setEditedSummary={noopSetEditedSummary}
      TOOLTIP_STEPS={{}}
    />
  );
};

export default ConsultNoteSummary;
